import React from 'react';

import { AclPermissionsRole } from '@eventmanager/types';
import { Image } from '../Image';
import { c, getPlanImage, toTitleCase } from '../../utils';
import classes from './PlanHeader.module.scss';

interface Props {
  className?: string;
  planName: AclPermissionsRole | 'free';
}

// [2026-03-08] Renders the plan's visual identity, including the icon and name.
export function PlanHeader({ className, planName }: Props) {
  const image = getPlanImage(planName);

  return (
    <div className={c(classes.PlanHeader, className, 'flex gap-1 text-center')}>
      <Image src={image.src} alt={image.alt} />
      <h2 className="bold text-left">{toTitleCase(planName)}</h2>
    </div>
  );
}

export default PlanHeader;
